import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function StickyCta({ onBook }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const booking = document.getElementById("buchen");
      const bookingTop = booking ? booking.getBoundingClientRect().top : Infinity;
      setVisible(window.scrollY > window.innerHeight * 0.9 && bookingTop > window.innerHeight * 0.7);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="sticky-cta"
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-50 md:inset-x-auto md:right-8 md:bottom-8"
        >
          <div className="flex items-center justify-between gap-3 rounded-full border border-line bg-cream/90 py-2 pl-4 pr-2 backdrop-blur-md">
            <span className="hidden sm:block text-xs md:text-sm font-light text-taupe whitespace-nowrap">
              LOSLASSEN · Do, 03.09.2026 · 20:00 Uhr
            </span>
            <button
              data-testid="sticky-booking-button"
              onClick={onBook}
              className="rounded-full bg-espresso px-4 py-2.5 md:px-6 md:py-3 text-xs md:text-sm font-medium tracking-wide text-cream whitespace-nowrap transition-transform duration-300 hover:scale-[1.04] active:scale-[0.97]"
            >
              Platz sichern · CHF 21.–
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
